import '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import { sumArray, reduceFractionArray } from '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';

function mapColumnCount(split) {
  var count = sumArray(reduceFractionArray(split));

  switch (count) {
    case 1:
      return 'grid-cols-1';

    case 2:
      return 'grid-cols-2';

    case 3:
      return 'grid-cols-3';

    case 4:
      return 'grid-cols-4';

    case 5:
      return 'grid-cols-5';

    default:
      return undefined;
  }
}

function useDescriptionListStyles(layout, split) {
  var classNames = [];

  if (layout === 'column') {
    classNames.push('grid', 'gap-2', mapColumnCount(split));
  }

  return classNames;
}
function mapColumnWidth(width) {
  switch (width) {
    case 1:
      return 'col-span-1';

    case 2:
      return 'col-span-2';

    case 3:
      return 'col-span-3';

    case 4:
      return 'col-span-4';

    default:
      return undefined;
  }
}

export { mapColumnWidth, useDescriptionListStyles };
//# sourceMappingURL=styles.esm.js.map
